// extracted by mini-css-extract-plugin
export var actions = "_qn-5";
export var assistantBubble = "_qn-3";
export var assistantRow = "_qn-6";
export var bubble = "_qn-0";
export var humanAvatar = "_qn-4";
export var inlineToolCard = "_qn-1";
export var userBubble = "_qn-2";